define([
	"dojo/_base/declare",
	"csi/def/Action",
	"csi/state/rootStore",
	"csi/xml"
], function(declare,Action,{ routerStore },xml) {

	return declare(Action, {
		bCheckReadOnlyView: true,

		constructor: function(def) {
			// set appropriate rights for action - need to be careful due to freeze action setting node read-only flag
			this.setBaseRights(xml.RIGHT_WRITE);

			// optimize action by not returning all modified nodes from publish
			this.setReturnParameters();
		},

		checkNodeAccess: function(node) {
			if (!xml.nodeHasRight(node, this.m_right) || !xml.nodeHasRight(node, this.m_rightBase) || routerStore.locationIsDormant)
				return false;

			if (node && (xml.rightIsMore(this.m_right, xml.RIGHT_READ) >= 0 || xml.rightIsMore(this.m_rightBase, xml.RIGHT_READ) >= 0) ) {
				if (xml.nodeHasFlag(node, xml.NODE_FLAG_NOEDIT))
					return false;
			}

			return true;
		}
	});
});